import React from 'react';
import { sendAnalytics } from 'utils/analyticsUtils';
import { notifyRedirectToTicketWidget } from '../LoginPopover';
import {
    sendCustomClick
} from '../../../../utils/SnowplowUtils';
import {
    buttonTypes,
    loginSubCategory,
    registerSubCategory
} from '../../../../constants/SnowplowConst';
import { loginSpinnerOrigin } from '../../../../constants/Enums';

export const LoginRestriction = ({
    onLoginClick,
    eventUrls: { registrationsUrl },
    text,
    isWebLoginV2Used,
    isWidget,
    analyticData,
    setLoginV2SpinnerOrigin,
    setLoginV2OffsetTop,
    loginV2LoadingState,
}) => {
    const handleLogin = (event) => {
        sendAnalytics('loginClick', analyticData);
        sendCustomClick(buttonTypes.login, loginSubCategory.loginRestrictionButton, event.currentTarget);
        const isLoginOnEmbedded = isWebLoginV2Used && isWidget && window.self !== window.parent;
        if (isLoginOnEmbedded) {
            setLoginV2OffsetTop?.(event.pageY);
        }
        onLoginClick();
        setLoginV2SpinnerOrigin?.(loginSpinnerOrigin.ANIMATED_RESTRICTION);
    };

    const handleRegister = (event) => {
        sendCustomClick(buttonTypes.register, registerSubCategory.registerRestrictionButton, event.currentTarget);
        notifyRedirectToTicketWidget();
    };

    const isLoginV2Loading = loginV2LoadingState.isLoading
        && loginV2LoadingState.spinnerOrigin === loginSpinnerOrigin.ANIMATED_RESTRICTION;

    return (
        <div className="restriction-reason">
            <div className="reason-text">{text}</div>
            <div className="cta-container">
                <a
                    href={registrationsUrl}
                    onClick={handleRegister}
                    className="cta-button cta-button-small font-size-12 custom-color color-1 color-1-border color-1-hover-opacity-outline"
                    target="_top"
                >
                    Register
                </a>
                <button
                    onClick={handleLogin}
                    className="cta-button cta-button-small font-size-12 custom-color color-1-background margin-left-small color-1-hover-opacity"
                >
                    {isLoginV2Loading ? <i className="fa fa-spinner fa-spin font-size-17"/> : 'Login'}
                </button>
            </div>
        </div>
    );
};


export const WithoutCallToActionRestriction = ({ text }) => (
    <div className="restriction-reason">
        <div className="reason-text">
            {text}
        </div>
    </div>
);
